module.exports = __webpack_public_path__ + "img/logo1.f0d7bdea.png";